(function () {
  document.querySelectorAll('.rte-clean p').forEach((paragraph) => {
    if (paragraph.closest('table')) return;
    const hasMedia = paragraph.querySelector('img, iframe, video, picture, svg, object, embed');
    const text = (paragraph.textContent || '').replace(/\u00a0/g, ' ').trim();
    if (!hasMedia && text === '') {
      paragraph.remove();
    }
  });
})();
